/**
 * TC - Enrollment Services v1.0.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

namespace Portico.Models.Legacy {
    import models = Portico.Models.Legacy;
    export class UpdatePrescriberRequestModel {
        prescriberId: string;
        firstName: string;
        lastName: string;
        phoneNumbers: Array<models.PhoneNumberModel>;
        address1: string;
        address2: string;
        city: string;
        country: string;
        state: string;
        postalCode: string;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.UpdatePrescriberRequestModel){
            this.prescriberId = null;
            this.firstName = null;
            this.lastName = null;
            this.phoneNumbers = null;
            this.address1 = null;
            this.address2 = null;
            this.city = null;
            this.country = null;
            this.state = null;
            this.postalCode = null;

            if(obj){
                this.prescriberId = obj.prescriberId || null;
                this.firstName = obj.firstName || null;
                this.lastName = obj.lastName || null;
                this.phoneNumbers = (obj.phoneNumbers || []).map(item => new models.PhoneNumberModel(item || null));
                this.address1 = obj.address1 || null;
                this.address2 = obj.address2 || null;
                this.city = obj.city || null;
                this.country = obj.country || null;
                this.state = obj.state || null;
                this.postalCode = obj.postalCode || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.UpdatePrescriberRequestModel {
            return {
                prescriberId: this.prescriberId,
                firstName: this.firstName,
                lastName: this.lastName,
                phoneNumbers: this.phoneNumbers.map(item => item.toModel()),
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                country: this.country,
                state: this.state,
                postalCode: this.postalCode,
            };
        }
    }
}
